/* eslint-disable import/no-default-export */
import React, { useState } from "react";
import { InstallationVersions } from "../types/types";
import { BackToListButton } from "../components/Misc/BackToListButton";
import { ChartDataManager } from "./ChartDataManager";
import { NodeInfoManager } from "../components/NodeInfo/NodeInfoManager";

import { useChart } from "../contexts/ChartDataContext";
import { PortalModal } from "../components/PortalModal/PortalModal";
import { InstallationConfigModal } from "../components/SensorData/InstallationConfigModal";

import { PageTitleBox } from "../components/Misc/PageTitleBox";
import { Button } from "../components/Misc/Buttons/Button";
import { useTranslation } from "react-i18next";


export default function SensorDataContainer(): React.ReactElement {
  const [showInstallationConfigModal, setShowInstallationConfigModal] = useState(false);
  
  const chart = useChart();

  const { nodes } = useChart();
  const { t } = useTranslation();

  function getFormattedTime(time: string) {
    const date = new Date(time)
    return date.toLocaleDateString("en-GB")
  }

  return (
    <>
      <PageTitleBox
        rightContainer={chart.installation.version === InstallationVersions.MK2
          ? <Button
              onClick={() => setShowInstallationConfigModal(true)}
            >
              <i className="fas fa-gear" />
            </Button>
          : <></>
        }
      >
        <BackToListButton archive={chart.installation.archived_time != null} />
        <div>
          <h4>
            {chart.installation.name} (ID:&nbsp;{chart.device_id})
          </h4>
          <p>{t("Registered on {{date}}", {date: getFormattedTime(chart.installation.created_time)})}</p>
          {chart.installation.archived_time &&
            <p>{t("Archived on {{date}}", {date: getFormattedTime(chart.installation.archived_time)})}</p>
          }
        </div>
      </PageTitleBox>
      <ChartDataManager />
      <NodeInfoManager
        nodes={nodes}
      />
      <PortalModal
        isOpen={showInstallationConfigModal}
        close={() => setShowInstallationConfigModal(false)}
      >
        <InstallationConfigModal 
          device_id={chart.device_id}
          installation={chart.installation}
          onUpdate={chart.refreshInstallationInfo}
          close={() => setShowInstallationConfigModal(false)}
        />
      </PortalModal>
    </>
  );
}
